import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import ImageIcon from '@material-ui/icons/Image';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Remove from '@material-ui/icons/DeleteForeverSharp';

import { SERVER_BASE_URL } from '../constants';

const styles = theme => ({
  list: {
    width: '100%',
    maxWidth: 460,
  }
});

function FilesList(props) {

  const getItems = () => {
    const { list, deleteItem, folderName } = props;
    if (list.constructor === Array) {
      return list.map((l, idx) => {
        const getName = l.image.split(`${folderName}/`);

        return (
          <ListItem
            key={idx}
            onClick={() => window.open(`${SERVER_BASE_URL}${l.image}`, 'Image', 'nodeIntegration=yes')}
            style={{ cursor: 'pointer' }}>
            <Avatar>
              <ImageIcon />
            </Avatar>
            <ListItemText primary={getName[1]} />
            <ListItemSecondaryAction>
            <IconButton aria-label="Comments">
              <Remove onClick={() => deleteItem(l.id)}/>
            </IconButton>
          </ListItemSecondaryAction>
          </ListItem>
        );
      })
    } else {
      return (
        <ListItem
          onClick={() => window.open(`${SERVER_BASE_URL}${list}`, 'Image', 'nodeIntegration=yes')}
          style={{ cursor: 'pointer' }}>
          <Avatar>
            <ImageIcon />
          </Avatar>
          <ListItemText primary={list} />
          <ListItemSecondaryAction>
            <IconButton aria-label="Comments">
              <Remove onClick={() => deleteItem()}/>
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      );
    }
  }

  return (
    <List className={props.classes.list}>
      {getItems()}
    </List>
  )
}

FilesList.propTypes = {
  list: PropTypes.array,
  classes: PropTypes.object
}

export default withStyles(styles)(FilesList);
